import React from "react";
import { Link } from "react-router-dom";
import { FiHome } from "react-icons/fi";

function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        marginBottom: "22px"
      }}
    >
      <ol
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "8px",
          listStyle: "none",
          padding: 0,
          margin: 0,
          fontSize: "14px",
          color: "#94a3b8"
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isHome = index === 0;

          return (
            <React.Fragment key={item.label}>
              <li>
                {isLast ? (
                  <span
                    style={{
                      color: "#e2e8f0",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px"
                    }}
                  >
                    {isHome ? (
                      <FiHome size={14} />
                    ) : (
                      item.label
                    )}
                  </span>
                ) : (
                  <Link
                    to={item.to}
                    style={{
                      color: "#94a3b8",
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      transition: "color 0.2s ease"
                    }}
                  >
                    {isHome ? (
                      <FiHome size={14} />
                    ) : (
                      item.label
                    )}
                  </Link>
                )}
              </li>

              {!isLast && (
                <li
                  style={{
                    opacity: 0.45,
                    userSelect: "none"
                  }}
                >
                  /
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;